import { NavigationList } from "../types/NavigationList.ts";
import { solutionsNavigationDataWithHrefs } from "./solutionsNavigationData.tsx";

export const navigationData: NavigationList = [
  {
    name: "Overview",
    key: "overview",
    description: "Overview description",
    children: [
      {
        name: "Getting Started",
        key: "getting-started",
        href: "/",
        description: "Getting started description",
        children: [],
      },
      {
        name: "Targets",
        key: "target",
        href: "/target",
        description: "Targets description",
        children: [],
      },
      {
        name: "Emissions Profile",
        key: "baseline",
        href: "/baseline",
        description: "Emissions Profile description",
        children: [],
      },
    ],
  },
  {
    name: "Emissions Reduction",
    key: "emissions-reduction",
    description: "Emissions Reduction description",
    children: [
      {
        name: "Solutions",
        key: "plan",
        href: "/plan",
        description: "Solutions description",
      },
      ...solutionsNavigationDataWithHrefs,
      {
        name: "Your Plan",
        key: "dashboard",
        href: "/dashboard",
        description: "Dashboard description",
      },
    ],
  },
  {
    name: "Help",
    key: "help",
    description: "Help description",
    children: [
      {
        name: "Tour",
        key: "guided-tour",
        href: "/guided-tour",
        description: "Guided Tour description",
        children: [],
      },
      {
        name: "FAQ",
        key: "learn-more",
        href: "/learn-more",
        description: "FAQ description",
        children: [],
      },
      {
        name: "Contact Us",
        key: "contact-us",
        href: "/contact-us",
        description: "Contact us description",
        children: [],
      },
    ],
  },
];
